import { FieldConfig } from '../../../models/field-config';
import { FieldType } from '../../../models/field-type';
import { FormConfig } from '../../../models/form-config';
import {AgreementModel, AgreementValueModel} from '../../../../core/models/agreement.model';
import { AgreementsService } from '../../../services/agreements.service';
import { Validator } from '../../../models/validator.enum';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

export class AgreementsSectionConfig {

  language: string;
  service: AgreementsService;

  createSectionConfig(language: string,
                      agreementsService: AgreementsService): FormConfig {
    this.language = language.toUpperCase();
    this.service = agreementsService;

    return {
      formKey: 'SUMMARY_SECTION',
      fieldsConfig: []
    };
  }

  createOfferAgreementConfig(offerAgreement: AgreementModel): FieldConfig {
    const agreementShortValue = this.getAgreementValue(offerAgreement).shortValue;
    const agreementValue = agreementShortValue ? agreementShortValue : this.getAgreementValue(offerAgreement).value
    return {
      fieldKey: offerAgreement.code,
      fieldsDataFormat: 'objectArray',
      captionAsHTML: offerAgreement.details.required ? `${this.service.REQUIRED_SYMBOL} ${agreementValue}` : agreementValue,
      type: FieldType.Checkbox,
      validators: offerAgreement.details.required ? [Validator.REQUIRED_TRUE] : [],
      beanConfig: {
        keyPropertyName: 'code'
      },
      checkboxConfig: {
        readonly: false,
        expand: this.getCheckboxConfigExpand(offerAgreement),
        mappingConfig: {
          propertyName: 'selectedAnswer',
          valuesMapping: this.service.getValuesMapping(offerAgreement)
        }
      }
    };
  }

  private getCheckboxConfigExpand(offerAgreement: AgreementModel): any {
    if (isNotNullOrUndefined(this.getAgreementValue(offerAgreement).shortValue)) {
      return {
        expandedLabel: 'SHARED.AGREEMENTS.showAgreementFullText',
        collapsedLabel: 'SHARED.AGREEMENTS.hideAgreementFullText',
        expandText: this.getAgreementValue(offerAgreement).value
      };
    }
    return null;
  }

  private getAgreementValue(agreement: AgreementModel): AgreementValueModel {
    const agreementValues = agreement.details.values.filter(item => item.languageCode.toUpperCase() === this.language);
    if (agreementValues.length > 0) {
      return agreementValues[0];
    } else {
      throw new Error(`Agreement does not contain value for given language code: ${this.language}.`);
    }
  }

}
